import { useTranslation } from 'react-i18next';
import Layout from '@/components/Layout';
import Reveal from '@/components/Reveal';
import SEO from '@/components/SEO';
import CaseStudy from '@/components/CaseStudy';
import { SectionLabel, PrimaryButton } from '@/components/Button';

export default function Work() {
  const { t } = useTranslation(['work', 'common']);
  const cases = t('cases', { returnObjects: true });

  return (
    <Layout>
      <SEO title={t('seo.title')} description={t('seo.description')} />

      <section className="pt-32 md:pt-40 pb-16 md:pb-20" data-testid="work-hero">
        <div className="max-w-content mx-auto px-6 md:px-8 max-w-4xl">
          <Reveal>
            <SectionLabel>{t('hero.eyebrow')}</SectionLabel>
            <h1 className="mt-5 font-display text-4xl sm:text-5xl lg:text-[60px] font-semibold text-brand-primary leading-[1.06] tracking-tight">
              {t('hero.headline')}
            </h1>
            <p className="mt-7 text-[17px] md:text-lg text-brand-text leading-[1.8] max-w-[72ch]">
              {t('hero.body')}
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-10" data-testid="work-cases">
        <div className="max-w-content mx-auto px-6 md:px-8">
          {cases.map((c, i) => (
            <div key={c.number} className={i > 0 ? 'pt-20 md:pt-28 border-t border-black/10 mt-20 md:mt-28' : ''}>
              <CaseStudy
                number={c.number}
                title={c.title}
                organisation={c.organisation}
                situation={c.situation}
                approach={c.approach}
                result={c.result}
              />
            </div>
          ))}
        </div>
      </section>

      <section className="py-20 md:py-28 bg-brand-surface mt-20 md:mt-28" data-testid="work-references">
        <div className="max-w-content mx-auto px-6 md:px-8 grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <Reveal>
              <SectionLabel>{t('references.label')}</SectionLabel>
            </Reveal>
          </div>
          <div className="md:col-span-8 max-w-[72ch]">
            <Reveal delay={0.05}>
              <p className="font-display text-2xl md:text-[30px] text-brand-primary leading-snug tracking-tight">
                {t('references.body')}
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="py-24 md:py-32" data-testid="work-cta">
        <div className="max-w-content mx-auto px-6 md:px-8 max-w-3xl">
          <Reveal>
            <SectionLabel>{t('cta.label')}</SectionLabel>
            <h2 className="mt-5 font-display text-3xl md:text-[44px] font-semibold text-brand-primary leading-tight tracking-tight">
              {t('cta.headline')}
            </h2>
            <p className="mt-6 text-[17px] text-brand-text leading-[1.8] max-w-[68ch]">{t('cta.body')}</p>
            <div className="mt-10">
              <PrimaryButton to="/contact" testId="work-cta-button">{t('cta.startConversation', { ns: 'common' })}</PrimaryButton>
            </div>
          </Reveal>
        </div>
      </section>
    </Layout>
  );
}
